<header class="header">
  <div class="header-left">
    <svg id="headlogo" width="38" height="32" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_36383_66201)">
        <path d="M2.31044 0.101562L10.6911 9.68736C11.4016 10.509 11.8098 11.6109 11.8317 12.7663C11.8536 13.9216 11.4875 15.0427 10.8089 15.8988L10.8178 15.89L7.88817 19.241L2.31044 12.8612C1.57795 12.0234 0.996894 11.0287 0.600466 9.9341C0.204039 8.83945 0 7.66621 0 6.48136C0 5.29651 0.204039 4.12327 0.600466 3.02862C0.996894 1.93397 1.57795 0.939356 2.31044 0.101562Z" fill="#3BB979"/>
        <path d="M16.255 16.0556L10.6876 9.6875C11.3976 10.5095 11.8053 11.6114 11.827 12.7667C11.8487 13.922 11.4826 15.0429 10.804 15.8989L7.88846 19.2411C7.156 20.0788 6.57498 21.0733 6.17857 22.1678C5.78216 23.2623 5.57812 24.4354 5.57813 25.6202C5.57812 26.8049 5.78216 27.978 6.17857 29.0725C6.57498 30.1671 7.156 31.1616 7.88846 31.9992L16.255 22.4251C16.9931 21.5802 17.4076 20.4347 17.4076 19.2404C17.4076 18.046 16.9931 16.9005 16.255 16.0556Z" fill="url(#paint0_linear_36383_66201)"/>
        <path d="M35.1693 0L26.7886 9.5858C26.0789 10.4082 25.6713 11.5102 25.6494 12.6655C25.6275 13.8208 25.993 14.9419 26.6709 15.7987L26.6632 15.7885L29.5916 19.1394L35.1693 12.7596C35.9018 11.9218 36.4828 10.9272 36.8793 9.83253C37.2757 8.73788 37.4797 7.56464 37.4797 6.3798C37.4797 5.19495 37.2757 4.02171 36.8793 2.92706C36.4828 1.83241 35.9018 0.837793 35.1693 0V0Z" fill="#3BB979"/>
        <path d="M21.2213 15.9574L26.7888 9.58789C26.079 10.4103 25.6714 11.5122 25.6495 12.6676C25.6276 13.8229 25.9931 14.944 26.671 15.8008L29.5955 19.1459C31.0743 20.8383 31.9049 23.133 31.9049 25.5257C31.9049 27.9183 31.0743 30.2131 29.5955 31.9055L21.2213 22.3241C20.8558 21.906 20.5658 21.4098 20.368 20.8636C20.1702 20.3174 20.0684 19.732 20.0684 19.1408C20.0684 18.5495 20.1702 17.9641 20.368 17.4179C20.5658 16.8717 20.8558 16.3755 21.2213 15.9574Z" fill="url(#paint1_linear_36383_66201)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_36383_66201" x1="5.57827" y1="20.8441" x2="17.4133" y2="20.8441" gradientUnits="userSpaceOnUse">
          <stop stop-color="#71D8A4"/>
          <stop offset="1" stop-color="#71D8A4"/>
        </linearGradient>
        <linearGradient id="paint1_linear_36383_66201" x1="82599.7" y1="3171.77" x2="81505.3" y2="3171.77" gradientUnits="userSpaceOnUse">
          <stop stop-color="#71D8A4"/>
          <stop offset="1" stop-color="#71D8A4"/>
        </linearGradient>
        <clipPath id="clip0_36383_66201">
          <rect width="38" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>

    <button
      mat-icon-button
      class="icon primary sidebar-toggle-btn"
      [attr.aria-label]="'COMMON.TOGGLE_SIDEBAR_ARIA' | translate"      (click)="toggleSidebar.emit()">
      <mat-icon [svgIcon]="isSidebarCollapsed ? 'sidebar-expand' : 'sidebar-collapse'"></mat-icon>
    </button>
  </div>

  <div class="uni-flex uni-gap-1">
    <under-ui-global-search></under-ui-global-search>

    <under-ui-language-switcher>
    </under-ui-language-switcher>

    @if (isAvailableFullScreen) {
      <button
        mat-icon-button
        class="icon primary"
        [attr.aria-label]="(isFullScreen ? 'COMMON.EXIT_FULLSCREEN_ARIA' : 'COMMON.ENTER_FULLSCREEN_ARIA') | translate"
        (click)="fullScreen()">
        <mat-icon>
          {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
        </mat-icon>
      </button>
    }

    <button
      mat-icon-button
      class="icon primary"
      [attr.data-element-id]="elementId.UserProfileIcon"
      [attr.aria-label]="'COMMON.USER_PROFILE_ARIA' | translate"
      [matMenuTriggerFor]="menu">
      <mat-icon svgIcon="user"></mat-icon>
    </button>

    <button
      [@bellShake]="onAnimationRun()"
      (@bellShake.done)="onAnimationEnd()"
      mat-icon-button
      class="icon primary"
      [attr.aria-label]="'NOTIFICATIONS.PANEL.TITLE' | translate"
      (click)="toggleNotificationsSidebar()">
      <mat-icon
        svgIcon="bell"
        [matBadge]="unreadNotificationsCount"
        [matBadgeHidden]="!unreadNotificationsCount"
        matBadgeColor="warn"
        matBadgeSize="large"></mat-icon>
    </button>
  </div>
</header>

<mat-menu class="cancel-menu" #menu="matMenu" xPosition="before">
  <button mat-menu-item (click)="switchTheme()">
    <span>{{ getThemeSwitchLabel() | translate }}</span>
  </button>

  <button mat-menu-item [attr.data-element-id]="elementId.HeaderProfileLink" (click)="openProfile()">
    {{ "PROFILE.TITLE" | translate }}
  </button>

  <button mat-menu-item (click)="logout()">
    <span>{{ "COMMON.LOGOUT" | translate }}</span>
  </button>

</mat-menu>

